import {useSignal, useSignals} from '@preact/signals-react/runtime'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import moment from 'moment'
import {Button} from 'primereact/button'
import {Dialog} from 'primereact/dialog'
import {Divider} from 'primereact/divider'
import {forwardRef, useCallback, useImperativeHandle, useMemo} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'
import {dischargeKey} from '../discharge/DischargeConstant'
import {convertKeyToLabel} from '../table-utils/TableUtils'

const ExportDischargePdf = forwardRef(
    ({userData = {}, dischargeData = {}}, ref) => {
        useSignals()
        useImperativeHandle(ref, () => ({
            showForm: showForm,
            hideForm: hideForm,
        }))
        const {translateCommons} = TranslateUtils()
        const visible = useSignal(false)
        const createPDF = async () => {
            const pdf = new jsPDF('portrait', 'pt', 'a4')
            const data = await html2canvas(document.querySelector('#pdf'))
            const img = data.toDataURL('image/png')
            const imgProperties = pdf.getImageProperties(img)
            const pdfWidth = pdf.internal.pageSize.getWidth()
            // eslint-disable-next-line no-unused-vars
            const pdfHeight =
                (imgProperties.height * pdfWidth) / imgProperties.width
            pdf.addImage(img, 'PNG', 2, 2, 595, 626)
            pdf.save(
                'Patient-' +
                    userData?.fullName +
                    '-' +
                    userData?.nhsNumber +
                    '.pdf',
            )
        }
        const renderPathway = useCallback(() => {
            if (
                userData?.pathways &&
                Array.isArray(userData?.pathways) &&
                userData?.pathways.length > 0
            ) {
                let string = ''
                for (let i = 0; i < userData?.pathways.length; i++) {
                    string = userData?.pathways[i].name + ', ' + string
                }

                return string
            } else {
                return []
            }
        }, [userData])
        const gpDetail = useMemo(() => {
            if (
                userData &&
                userData.generalPractitioners &&
                Array.isArray(userData.generalPractitioners) &&
                userData.generalPractitioners.length > 0
            ) {
                return {
                    gpName: userData
                        ? userData?.generalPractitioners[0]?.name
                        : '-',
                    gpSurgery: userData
                        ? userData?.generalPractitioners[0]?.surgery
                        : '-',
                    gpEmail: userData
                        ? userData?.generalPractitioners[0]?.email
                        : '-',
                    gpAddress: userData
                        ? userData?.generalPractitioners[0]?.address
                        : '-',
                }
            } else {
                return {}
            }
        }, [userData])
        const leftUserList = {
            patientName: `${userData?.firstName} ${userData?.lastName}`,
            dateOfBirth: userData?.dob || '-',
            hospitalNumber: userData?.hospitalNumber || '-',
            NHSNo: userData?.nhsNumber || '-',
            admissionDate: userData?.createdAt
                ? moment(userData?.createdAt).format('yyyy-MM-DD HH:mm')
                : '-',
            DischargeDate: userData?.deletedAt
                ? moment(userData?.deletedAt).format('yyyy-MM-DD HH:mm')
                : '-',
            Pathway: renderPathway(),
            'GP Name': gpDetail.gpName || '-',
            'GP Surgery': gpDetail.gpSurgery || '-',
            'GP Email': gpDetail.gpEmail || '-',
            'GP Address': gpDetail.gpAddress || '-',
        }

        const hideForm = () => {
            visible.value = false
            unblockOverflownScroll()
        }
        const showForm = () => {
            visible.value = true
            blockOverflownScroll()
        }

        return (
            <div className="shipping">
                <Dialog
                    header="EXPORT PDF"
                    style={{width: '60vw'}}
                    breakpoints={{'960px': '75vw', '641px': '100vw'}}
                    visible={visible.value}
                    className="discharge-dialog"
                    onHide={() => hideForm()}>
                    <div
                        className="col-12 p-5 mb-3"
                        style={{backgroundColor: 'whitesmoke'}}>
                        <div id="pdf">
                            <div
                                style={{
                                    borderTop: '5px solid darkcyan',
                                    borderBottom: '5px solid darkcyan',
                                    backgroundColor: 'white',
                                }}>
                                <div className="col-12 text-center">
                                    <h1 className="font-bold mb-2">
                                        {translateCommons(
                                            'Virtual Ward Discharge Summary',
                                        )}
                                    </h1>
                                    <h2
                                        className="mb-2 font-bold"
                                        style={{color: 'darkcyan'}}>
                                        {userData?.hospitalName}
                                    </h2>
                                </div>
                                <Divider className="mb-0">
                                    <span>
                                        <h6
                                            className="font-bold text-xl mb-0"
                                            style={{
                                                color: 'darkcyan',
                                                backgroundColor: 'white',
                                            }}>
                                            <span className="mr-2">
                                                <i className="pi pi-user font-bold font-italic text-xl"></i>
                                            </span>
                                            <i>
                                                {translateCommons(
                                                    'Patient Information',
                                                )}
                                            </i>
                                        </h6>
                                    </span>
                                </Divider>
                                <div className="flex justify-content-between col-12">
                                    <div className="col-12 flex align-items-center justify-content-center">
                                        <div className="col-12">
                                            {Object.keys(leftUserList).map(
                                                key => (
                                                    <div
                                                        key={key}
                                                        className="flex col-12 text-xl ">
                                                        <div className="col-4 font-bold">
                                                            {convertKeyToLabel(
                                                                key,
                                                            )}{' '}
                                                            :{' '}
                                                        </div>{' '}
                                                        <div className="col-8">
                                                            {leftUserList[key]}{' '}
                                                        </div>
                                                    </div>
                                                ),
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <Divider className="mb-0">
                                    <span>
                                        <h6
                                            className="font-bold text-xl mb-0"
                                            style={{
                                                color: 'darkcyan',
                                                backgroundColor: 'white',
                                            }}>
                                            <span className="mr-2">
                                                <i className="pi pi-list font-bold font-italic text-xl"></i>
                                            </span>
                                            <i>
                                                <i>
                                                    {translateCommons(
                                                        'Discharge Information',
                                                    )}
                                                </i>
                                            </i>
                                        </h6>
                                    </span>
                                </Divider>
                                <div className="col-12 ml-3">
                                    {dischargeData &&
                                        Object.keys(dischargeKey).map(
                                            key =>
                                                key !==
                                                    'dischargeInformation' && (
                                                    <div
                                                        key={key}
                                                        className="flex col-12 text-xl ">
                                                        <div className="col-4 font-bold">
                                                            {convertKeyToLabel(
                                                                key,
                                                            )}
                                                        </div>{' '}
                                                        <div className="col-8">
                                                            {dischargeData[key]}{' '}
                                                        </div>
                                                    </div>
                                                ),
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="col-12 px-5 mb-5"
                        style={{backgroundColor: 'whitesmoke'}}>
                        <Button
                            className="col-12 p-3  mb-5"
                            label="EXPORT"
                            icon="pi pi-file"
                            onClick={createPDF}
                        />
                    </div>
                </Dialog>
                {console.log(userData)}
            </div>
        )
    },
)

export default ExportDischargePdf
